import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import cookieStorage from './cookie';

export type TSettingsState = {
  expandSearch: boolean;
  searchQuery: string;
  setExpandSearch: (enabled: boolean) => void;
  setSearchQuery: (query: string) => void;

  isKaraoke: boolean;
  setIsKaraoke: (value: boolean) => void;

  volume: number;
  setVolume: (value: number) => void;
};

export const useSettingsStore = create<TSettingsState>()(
  persist(
    (set) => ({
      expandSearch: false,
      searchQuery: '',
      setExpandSearch: (expand: boolean) => set({ expandSearch: expand }),
      setSearchQuery: (query: string) => set({ searchQuery: query }),

      isKaraoke: false,
      setIsKaraoke: (value) => {
        set({ isKaraoke: value });
      },

      volume: 1,
      setVolume: (value) => {
        set({ volume: value });
      },
    }),
    {
      name: 'settings-storage',
      storage: createJSONStorage(() => cookieStorage),
      partialize: (state) => ({
        isKaraoke: state.isKaraoke,
        volume: state.volume,
      }),
    },
  ),
);
